import React from 'react'
import { useForm } from 'react-hook-form'

import CustomSelect from '../CustomSelect'
import CountryField from '../CountryField'

export default function Form(props) {
  const {
    isInline,
    handleSubmitEvent,
    updateInputState,
    formInputs,
    submitLabel,
    submitClass,
    countriesOptions,
    onCountriesFetched,
    i18n,
  } = props

  const { auxiliaryInstructors, association, country } = formInputs
  const { handleSubmit, errors, control } = useForm()

  const booleanOptions = [
    { value: true, label: i18n.t('academyRegistration.form.yes') },
    { value: false, label: i18n.t('academyRegistration.form.no') },
  ]

  return (
    <form
      onSubmit={handleSubmit(handleSubmitEvent)}
      className={isInline && 'form-inline d-none d-xl-flex'}
      noValidate
    >
      <CountryField
        updateInputState={updateInputState}
        defaultValue={country}
        countriesOptions={countriesOptions}
        country={country}
        errors={errors}
        control={control}
        label={i18n.t('academyRegistration.form.academyCountry')}
        fieldName="country"
        placeholder={i18n.t('academyRegistration.form.selectOption')}
        fieldId="country-field"
        onCountriesFetched={onCountriesFetched}
      />

      <div className="form-group">
        <label htmlFor="auxiliary-instructors-field">
          {i18n.t('academyRegistration.form.additionalInstructors')}
        </label>

        <CustomSelect
          name="auxiliary-instructors"
          value={auxiliaryInstructors}
          defaultValue={auxiliaryInstructors}
          options={booleanOptions}
          control={control}
          errors={errors}
          id="auxiliary-instructors-field"
          placeholder={i18n.t('academyRegistration.form.selectOption')}
          onChange={(selected) => {
            if (!selected) return null

            updateInputState({
              target: {
                name: 'auxiliaryInstructors',
                value: selected[0],
              },
            })

            return selected
          }}
        />
      </div>

      <div className="form-group">
        <label htmlFor="association-field">
          {i18n.t('academyRegistration.form.associationParticipant')}
        </label>

        <CustomSelect
          name="association"
          value={association}
          defaultValue={association}
          options={booleanOptions}
          control={control}
          errors={errors}
          id="association-field"
          placeholder={i18n.t('academyRegistration.form.selectOption')}
          onChange={(selected) => {
            if (!selected) return null

            updateInputState({
              target: {
                name: 'association',
                value: selected[0],
              },
            })

            return selected
          }}
        />
      </div>

      <button type="submit" className={`btn ${submitClass}`}>
        {submitLabel}
      </button>
    </form>
  )
}
